var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#8D8599",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.09 17.958H7.402l-.149-2.42-.366-.149-1.822 1.599-3.3-3.309 1.59-1.822c-.052-.12-.104-.239-.15-.365l-2.419-.15v-4.69l2.42-.149c.045-.127.097-.246.15-.366L1.755 4.315l3.308-3.308 1.822 1.598.366-.149.15-2.42h4.689l.15 2.42.365.15 1.815-1.599 3.315 3.3-1.598 1.83c.052.12.105.24.15.359l2.419.157v4.69l-2.42.156c-.052.12-.096.239-.156.358l1.613 1.83-3.316 3.308-1.814-1.606-.366.15-.157 2.42Zm-3.285-1.493h1.882l.135-2.046.5-.142a5.38 5.38 0 0 0 1.053-.433l.455-.247 1.538 1.374 1.352-1.351-1.352-1.539.247-.455a5.38 5.38 0 0 0 .433-1.053l.15-.5 2.015-.135V8.057l-2.038-.135-.15-.5a6.13 6.13 0 0 0-.433-1.053l-.246-.456 1.374-1.538-1.359-1.351-1.538 1.344-.456-.24a5.412 5.412 0 0 0-1.053-.44l-.5-.142-.127-2.016H8.805L8.671 3.57l-.5.149a5.586 5.586 0 0 0-1.053.433l-.456.247L5.17 3.053l-1.397 1.33 1.344 1.493-.246.456a5.974 5.974 0 0 0-.433 1.06l-.15.5-2.008.165v1.881l2.038.135.15.493c.11.366.255.721.433 1.06l.246.455-1.374 1.531 1.36 1.36 1.493-1.345.463.24c.334.183.687.33 1.053.44l.5.142.164 2.016Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.746 12.731a3.734 3.734 0 1 1 0-7.468 3.734 3.734 0 0 1 0 7.468Zm0-5.974a2.24 2.24 0 1 0 0 4.48 2.24 2.24 0 0 0 0-4.48Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z",
    transform: "translate(.749)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.047d0857.svg";
export { ForwardRef as ReactComponent };